import type { ComponentType } from "react";
import type { SlideProps } from "@/engine/app/offsite-config";
import { Slide01Titel } from "./slides/Slide01Titel";
import { Slide02Einfuehrung } from "./slides/Slide02Einfuehrung";
import { SlideThema } from "./slides/SlideThema";
import { Slide03Prompten } from "./slides/Slide03Prompten";
import { SlideArbeitsphase } from "./slides/SlideArbeitsphase";
import { SlideSpikes } from "./slides/SlideSpikes";
import { Slide04Reveal } from "./slides/Slide04Reveal";

/**
 * Sieben Folien für 25 Minuten, in der Reihenfolge des Ablaufs.
 *
 *   0 Titel          — Minute 0
 *   1 Einführung     — Minute 0–3
 *   2 Zugang         — Adresse, PIN, QR groß: Warten auf die Gäste
 *   3 Themenwahl     — die Runde entscheidet; QR läuft klein nebenher weiter
 *   4 Arbeitsphase   — die Zeit groß in der Mitte, Code als Kulisse
 *   5 Generierung    — Fortschritt in Kästchen, während SVO OS daneben läuft
 *   6 Reveal         — Minute 21–25
 *
 * Die Reihenfolge muss der Schrittfolge im Moderatorpult folgen. Stand die
 * Themenwahl davor, sprang die Leinwand beim Weitergehen von Folie 3 zurück auf
 * 2 und von dort auf 4 — die Foliennummer unten lief dabei sichtbar rückwärts.
 *
 * Die Nummern in den Dateinamen sind historisch. Verbindlich ist diese
 * Reihenfolge und die Indizes in `offsite.config.ts` — nicht der Dateiname.
 */
export const SLIDE_COMPONENTS: ComponentType<SlideProps>[] = [
  Slide01Titel,
  Slide02Einfuehrung,
  Slide03Prompten,
  SlideThema,
  SlideArbeitsphase,
  SlideSpikes,
  Slide04Reveal,
];

export type { SlideProps } from "@/engine/app/offsite-config";
